<div [ngClass]="pageClass">
  <app-header></app-header>

  <div [ngClass]="contentClass">
    <!-- Header Section -->
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <!-- Main Content -->
    <div [ngClass]="mainClass">
      <div [ngClass]="pageInnerClass">
        <div class="asset-listing--warning" *ngIf="warningMessage" role="status">
          <svg class="asset-listing--warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>{{ warningMessage }}</span>
        </div>
        <!-- Collection tabs (above filter) -->
        <div class="asset-listing--tabs-wrapper" *ngIf="showCollectionTabs">
          <div class="asset-listing--tabs" role="tablist">
            <button
              *ngFor="let tab of collectionTabs"
              type="button"
              class="asset-listing--tab"
              role="tab"
              [class.active]="activeCollectionTab === tab.id"
              [attr.aria-selected]="activeCollectionTab === tab.id"
              (click)="onCollectionTabClick(tab.id)"
            >
              <svg
                *ngIf="isCollectionTabLocked(tab.id)"
                class="asset-listing--tab-lock-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ getCollectionTabLabel(tab) }}
            </button>
          </div>
        </div>

      <div [ngClass]="containerClass" [class.collection-interaction-mode]="isInteractionModeActive">
        <!-- Filter Sidebar (Desktop) -->
        <aside [ngClass]="sidebarClass" *ngIf="!isInteractionModeActive">
      <app-asset-filter
        [config]="filterConfig"
        [searchPlaceholder]="filterSearchPlaceholder"
        [isLoggedIn]="isLoggedIn"
        [disabled]="isInteractionModeActive"
        (filterChange)="onFilterChange($event)"
        (resetFilters)="onResetFilters()"
        (sectionExpandChange)="onFilterSectionExpandChange()"
        (searchChange)="onSearchChange($event)"
      ></app-asset-filter>
        </aside>

        <!-- Grid Section -->
        <main [ngClass]="gridClass">
          <app-asset-grid
            [assets]="assets"
            [assetType]="assetType"
            [initialCollectionTab]="initialCollectionTab"
            [searchPlaceholder]="searchPlaceholder"
            [searchQuery]="searchQuery"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [viewMode]="viewMode"
            [itemsPerPage]="itemsPerPage"
            [showMobileFilterButton]="showMobileFilterButton && !isInteractionModeActive"
            [isLoggedIn]="isLoggedIn"
            (pageChange)="onPageChange($event)"
            (viewModeChange)="onViewModeChange($event)"
            (searchChange)="onSearchChange($event)"
            (itemsPerPageChange)="onItemsPerPageChange($event)"
            (openMobileFilter)="onOpenMobileFilter()"
            [sortOption]="sortOption"
            (bookmarksClick)="bookmarksClick.emit()"
            (likeClick)="likeClick.emit()"
            (sortChange)="onSortChange($event)"
            (interactionModeChange)="onInteractionModeChange($event)"
            (collectionTabChange)="onCollectionTabChange($event)"
          ></app-asset-grid>
        </main>
      </div>
      </div>
    </div>
  </div>

  <!-- Optional bottom section (e.g. Contact Us form on Models page) -->
  <ng-content select="[bottomSection]"></ng-content>

  <app-footer></app-footer>

  <!-- Mobile Filter Modal -->
  <div [ngClass]="mobileFilterOverlayClass" 
       [class.active]="isMobileFilterOpen"
       (click)="onCloseMobileFilter()">
  </div>
  <div [ngClass]="mobileFilterModalClass" 
       [class.active]="isMobileFilterOpen">
    <div [ngClass]="mobileFilterHeaderClass">
      <h2 [ngClass]="mobileFilterTitleClass">{{ mobileFilterTitle }}</h2>
      <button [ngClass]="mobileFilterCloseClass" 
              (click)="onCloseMobileFilter()"
              aria-label="Close filters">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div [ngClass]="mobileFilterContentClass">
      <app-asset-filter
        [config]="filterConfig"
        [searchPlaceholder]="filterSearchPlaceholder"
        [isLoggedIn]="isLoggedIn"
        [disabled]="isInteractionModeActive"
        (filterChange)="onFilterChange($event)"
        (resetFilters)="onResetFilters()"
        (sectionExpandChange)="onFilterSectionExpandChange()"
        (searchChange)="onSearchChange($event)"
      ></app-asset-filter>
    </div>
    <div [ngClass]="mobileFilterFooterClass">
      <button [ngClass]="mobileFilterResetClass" 
              (click)="onResetFilters()"
              *ngIf="filterConfig.activeFilterCount > 0">
        Reset
      </button>
      <button [ngClass]="mobileFilterApplyClass" 
              (click)="onCloseMobileFilter()">
        Apply Filter ({{ filterConfig.activeFilterCount }})
      </button>
    </div>
  </div>
</div>
